// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb_sec":"Breadcrumbs_breadcrumb_sec__MNo58"};